(function () {
  'use strict';

  var root = document.querySelector('[data-ce-lead-pilot]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  var ATTRIBUTION_KEY = 'ce_lead_pilot_attribution_v2';
  var endpoint = (root.dataset.endpoint || '').trim();
  var beaconEndpoint = (root.dataset.beaconEndpoint || '').trim();
  var localEndpoint = new URLSearchParams(window.location.search).get('ce_pilot_endpoint');
  if (
    localEndpoint &&
    (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost')
  ) {
    endpoint = localEndpoint;
    beaconEndpoint = localEndpoint.replace(/\/$/, '') + '/beacon';
  }

  var environment = root.dataset.environment === 'production' ? 'production' : 'staging';
  var version = root.dataset.version || '2';
  var whatsappNumber = (root.dataset.whatsapp || '').replace(/\D/g, '');
  var whatsappText = root.dataset.whatsappText || 'Olá, gostaria de falar com a equipe da Cabo Eletro.';
  var storagePrefix = 'ce_lead_pilot_v2_' + environment;
  var sessionId = safeReadOrCreate(storagePrefix + '_session_id', uuid);
  var localLeadRef = createLeadReference(sessionId);
  var leadRef = safeReadOrCreate(storagePrefix + '_lead_ref', function () {
    return localLeadRef;
  });
  var attributionCapture = captureAttribution();
  var attribution = attributionCapture.payload;
  var form = root.querySelector('#ce-lead-pilot-form');
  var whatsappLink = root.querySelector('[data-ce-lead-pilot-whatsapp]');
  var whatsappStatus = root.querySelector('[data-ce-whatsapp-status]');
  var modal = root.querySelector('[data-ce-whatsapp-modal]');
  var modalForm = root.querySelector('[data-ce-whatsapp-modal-form]');
  var modalTitle = root.querySelector('[data-ce-whatsapp-modal-title]');
  var modalCloseButtons = root.querySelectorAll('[data-ce-whatsapp-modal-close]');
  var lastFocusedElement = null;

  updateDiagnostics('gclid', attribution.gclid ? 'Capturado' : 'Não informado', !!attribution.gclid);
  updateDiagnostics(
    'braid',
    attribution.gbraid || attribution.wbraid ? 'Capturado' : 'Não informado',
    !!(attribution.gbraid || attribution.wbraid)
  );
  updateDiagnostics('utm', formatUtm(attribution), hasUtm(attribution));
  updateDiagnostics(
    'landing',
    attribution.landing_url ? shortUrl(attribution.landing_url) : 'Não informada',
    !!attribution.landing_url
  );
  updateLeadReference(leadRef);
  prepareNativeForm();

  postEvent('page_view')
    .then(function (result) {
      rememberResult(result);
      updateDiagnostics('connection', 'Catalog Ops disponível', true);
    })
    .catch(function () {
      updateDiagnostics('connection', 'Catalog Ops indisponível; os canais continuam ativos', false);
    });

  if (form) {
    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;
      prepareNativeForm();
      sendEventBestEffort('form_submitted', {
        form: readContactForm(form)
      });
    });
  }

  if (whatsappLink && modal && modalForm) {
    whatsappLink.addEventListener('click', function (event) {
      event.preventDefault();
      openModal();
    });

    modalForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!modalForm.reportValidity()) return;

      var contact = readContactForm(modalForm);
      var whatsappUrl = buildWhatsAppUrl(contact);
      setStatus(whatsappStatus, 'Abrindo o WhatsApp. Referência: ' + leadRef + '.', 'success');

      sendEventBestEffort('whatsapp_prechat_submitted', { form: contact });
      sendEventBestEffort('whatsapp_clicked');
      closeModal(false);

      var popup = window.open(whatsappUrl, '_blank');
      if (popup) popup.opener = null;
      else window.location.assign(whatsappUrl);
    });

    Array.prototype.forEach.call(modalCloseButtons, function (button) {
      button.addEventListener('click', function () {
        closeModal(true);
      });
    });

    modal.addEventListener('keydown', handleModalKeydown);
  }

  function openModal() {
    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('ce-lead-pilot-modal-open');
    sendEventBestEffort('whatsapp_modal_opened');
    window.setTimeout(function () {
      var firstField = modalForm.querySelector('input:not([type="hidden"])');
      if (firstField) firstField.focus();
      else if (modalTitle) modalTitle.focus();
    }, 0);
  }

  function closeModal(restoreFocus) {
    modal.hidden = true;
    document.documentElement.classList.remove('ce-lead-pilot-modal-open');
    if (restoreFocus && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function handleModalKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(true);
      return;
    }
    if (event.key !== 'Tab') return;

    var focusable = modal.querySelectorAll(
      'button:not([disabled]), input:not([disabled]), textarea:not([disabled]), a[href]'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function prepareNativeForm() {
    if (!form) return;
    var referenceField = form.querySelector('[data-ce-reference-field]');
    var attributionField = form.querySelector('[data-ce-attribution-field]');
    if (referenceField) referenceField.value = leadRef;
    if (attributionField) attributionField.value = attributionSummary(attribution);
  }

  function readContactForm(target) {
    return {
      name: fieldValue(target, 'name'),
      email: fieldValue(target, 'email'),
      phone: fieldValue(target, 'phone') || null,
      message: fieldValue(target, 'message') || 'Pré-chat do WhatsApp na página piloto.'
    };
  }

  function fieldValue(target, field) {
    var input = target.querySelector('[data-ce-contact-field="' + field + '"]');
    return input ? String(input.value || '').trim() : '';
  }

  function buildPayload(eventType, extra) {
    var payload = {
      event_id: uuid(),
      session_id: sessionId,
      lead_ref: leadRef,
      event_type: eventType,
      environment: environment,
      occurred_at: new Date().toISOString(),
      pilot_version: version,
      attribution: attribution,
      page: {
        url: window.location.href,
        path: window.location.pathname,
        title: document.title,
        referrer: document.referrer || null,
        locale: document.documentElement.lang || navigator.language || null
      },
      consent_state: consentState(),
      client_context: {
        timezone: safeTimezone(),
        viewport: window.innerWidth + 'x' + window.innerHeight,
        online: navigator.onLine,
        first_touch: attributionCapture.firstTouch,
        last_touch: attributionCapture.lastTouch
      }
    };
    if (extra && extra.form) payload.form = extra.form;
    if (extra && extra.honeypot) payload.honeypot = extra.honeypot;
    return payload;
  }

  function postEvent(eventType, extra) {
    if (!endpoint) return Promise.reject(new Error('endpoint não configurado'));
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 1800);

    return fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildPayload(eventType, extra)),
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) {
            var detail = typeof body.detail === 'string' ? body.detail : 'HTTP ' + response.status;
            throw new Error(detail);
          }
          return body;
        });
      })
      .finally(function () {
        window.clearTimeout(timeout);
      });
  }

  function sendEventBestEffort(eventType, extra) {
    if (!beaconEndpoint) return false;
    var body = JSON.stringify(buildPayload(eventType, extra));
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(beaconEndpoint, body)) return true;
    } catch (error) {
      // Usa fetch keepalive abaixo.
    }
    try {
      fetch(beaconEndpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: body,
        keepalive: true
      }).catch(function () {});
      return true;
    } catch (error) {
      return false;
    }
  }

  function captureAttribution() {
    var state = safeParse(safeGet(ATTRIBUTION_KEY)) || {};
    var touch = state.first_touch || state.last_touch || currentTouch();
    var payload = {};
    [
      'gclid', 'gbraid', 'wbraid',
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'
    ].forEach(function (name) {
      if (touch && touch[name]) payload[name] = String(touch[name]).slice(0, 512);
    });

    if (!payload.gclid) {
      var cookieGclid = readGoogleClickId();
      if (cookieGclid) payload.gclid = cookieGclid;
    }
    if (touch && touch.landing_url) payload.landing_url = String(touch.landing_url).slice(0, 2048);
    if (touch && touch.referrer) payload.referrer = String(touch.referrer).slice(0, 2048);
    if (touch && touch.captured_at) payload.captured_at = touch.captured_at;

    return {
      payload: payload,
      firstTouch: state.first_touch || touch || null,
      lastTouch: state.last_touch || touch || null
    };
  }

  function currentTouch() {
    var params = new URLSearchParams(window.location.search);
    var touch = {};
    var found = false;
    [
      'gclid', 'gbraid', 'wbraid',
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'
    ].forEach(function (name) {
      var value = params.get(name);
      if (!value) return;
      touch[name] = value.slice(0, 512);
      found = true;
    });
    if (!found) return null;
    touch.captured_at = new Date().toISOString();
    touch.landing_url = window.location.href.split('#')[0].slice(0, 2048);
    touch.referrer = (document.referrer || '').slice(0, 2048) || null;
    return touch;
  }

  function readGoogleClickId() {
    var value = readCookie('_gcl_aw');
    if (!value) return '';
    try {
      value = decodeURIComponent(value);
    } catch (error) {
      return '';
    }
    var parts = value.split('.');
    if (parts.length < 3) return '';
    var clickId = parts.slice(2).join('.').trim();
    if (!clickId || clickId.length > 512 || /\s/.test(clickId)) return '';
    return clickId;
  }

  function readCookie(name) {
    var prefix = name + '=';
    var cookies = String(document.cookie || '').split(';');
    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index].trim();
      if (cookie.indexOf(prefix) === 0) return cookie.slice(prefix.length);
    }
    return '';
  }

  function buildWhatsAppUrl(contact) {
    var message = [
      whatsappText.replace(/\s+/g, ' ').trim(),
      '',
      'Nome: ' + contact.name,
      'E-mail: ' + contact.email,
      'Telefone: ' + contact.phone,
      'Referência: ' + leadRef
    ].join('\n');
    return 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(message);
  }

  function createLeadReference(value) {
    var compact = String(value || '').replace(/[^a-fA-F0-9]/g, '').toUpperCase();
    compact = (compact + '0000000000000000').slice(0, 16);
    return 'CE-' + compact.slice(0, 8) + '-' + compact.slice(8, 16);
  }

  function consentState() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return { available: false };
    return {
      available: true,
      analytics: callBoolean(privacy, 'analyticsProcessingAllowed'),
      marketing: callBoolean(privacy, 'marketingAllowed'),
      preferences: callBoolean(privacy, 'preferencesProcessingAllowed'),
      sale_of_data: callBoolean(privacy, 'saleOfDataAllowed')
    };
  }

  function callBoolean(target, method) {
    try {
      return typeof target[method] === 'function' ? !!target[method]() : null;
    } catch (error) {
      return null;
    }
  }

  function rememberResult(result) {
    if (!result || !result.lead_ref) return;
    leadRef = result.lead_ref;
    safeSet(storagePrefix + '_lead_ref', leadRef);
    updateLeadReference(leadRef);
    prepareNativeForm();
  }

  function updateLeadReference(value) {
    updateDiagnostics('lead_ref', value, true);
  }

  function updateDiagnostics(name, value, ok) {
    var element = root.querySelector('[data-ce-diagnostic="' + name + '"]');
    if (!element) return;
    element.textContent = value;
    element.dataset.state = ok ? 'ok' : 'missing';
  }

  function formatUtm(value) {
    var primary = [value.utm_source, value.utm_medium, value.utm_campaign].filter(Boolean);
    return primary.length ? primary.join(' / ') : 'Não informado';
  }

  function hasUtm(value) {
    return !!(
      value.utm_source || value.utm_medium || value.utm_campaign ||
      value.utm_term || value.utm_content
    );
  }

  function attributionSummary(value) {
    var parts = [];
    [
      'gclid', 'gbraid', 'wbraid',
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
      'landing_url'
    ].forEach(function (name) {
      if (value[name]) parts.push(name + '=' + value[name]);
    });
    return parts.join(' | ').slice(0, 4000) || 'sem atribuição identificada';
  }

  function shortUrl(value) {
    try {
      var url = new URL(value);
      return (url.hostname + url.pathname).slice(0, 120);
    } catch (error) {
      return String(value).slice(0, 120);
    }
  }

  function setStatus(element, message, state) {
    if (!element) return;
    element.textContent = message;
    element.dataset.state = state || '';
  }

  function safeTimezone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch (error) {
      return null;
    }
  }

  function safeReadOrCreate(key, factory) {
    try {
      var value = localStorage.getItem(key);
      if (value) return value;
      value = factory();
      localStorage.setItem(key, value);
      return value;
    } catch (error) {
      return factory();
    }
  }

  function safeSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      // O fluxo comercial não depende do armazenamento local.
    }
  }

  function safeGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeParse(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var random = Math.random() * 16 | 0;
      var value = character === 'x' ? random : (random & 0x3 | 0x8);
      return value.toString(16);
    });
  }
})();
